export const demandSteps = [
  {
    target: '#start-item',
    content: 'Esta página é destinada a exibir todas as suas demandas.',
    disableBeacon: true,
  },
  {
    target: '#left-filter',
    content: 'Usando o filtro à esquerda, você pode filtrar suas demandas por diversos critérios.',
  },
  {
    target: '#excel-report',
    content: 'Você pode extrair um relatório das demandas exibidas.',
  },
  {
    target: '#demand-status',
    content: 'Aqui você pode visualizar o status de cada demanda.',
  },
  {
    target: '#protocol-number',
    content: 'Este é o número do protocolo da demanda.',
  },
  {
    target: '#demand-infos',
    content: 'Todos as informacoes da demanda estão disponíveis aqui.',
  },
  {
    target: '#counter-proposal',
    content: 'Este botão permite que você faça uma contraproposta.',
  },
  {
    target: '#open-chat',
    content: 'Aqui você pode abrir o chat para falar das suas demandas.',
  },
  {
    target: '#accept-proposal',
    content: 'Aqui você aceitar ou recusar a proposta.',
  },
];
